import { render, staticRenderFns } from "./ImportVideoModal.vue?vue&type=template&id=4bfbc731&scoped=true&"
import script from "./ImportVideoModal.vue?vue&type=script&lang=js&"
export * from "./ImportVideoModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportVideoModal.vue?vue&type=style&index=0&id=4bfbc731&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfbc731",
  null
  
)

export default component.exports